import React from 'react';
import { Smiley, SmileyMeh, SmileySad } from 'phosphor-react';
import { StepReaction } from '../../types/enums';

interface ReactionOption {
  value: StepReaction;
  label: string;
  icon: React.ReactNode;
  color: string;
}

const REACTIONS: ReactionOption[] = [
  { value: StepReaction.GREAT,     label: 'Ótimo',   icon: <Smiley className="w-5 h-5" />,    color: 'text-sage-600 bg-sage-50 border-sage-200 dark:bg-sage-900/20 dark:border-sage-700' },
  { value: StepReaction.NEUTRAL,   label: 'Neutro',  icon: <SmileyMeh className="w-5 h-5" />, color: 'text-nude-500 bg-nude-50 border-nude-200 dark:bg-gray-700 dark:border-gray-600' },
  { value: StepReaction.IRRITATED, label: 'Irritou', icon: <SmileySad className="w-5 h-5" />, color: 'text-red-500 bg-red-50 border-red-200 dark:bg-red-900/20 dark:border-red-800' },
];

interface ReactionSelectorProps {
  value?: StepReaction | string | null;
  onChange: (value: StepReaction | null) => void;
}

export default function ReactionSelector({ value, onChange }: ReactionSelectorProps) {
  return (
    <div className="flex gap-2">
      {REACTIONS.map((r) => (
        <button
          key={r.value}
          onClick={() => onChange(value === r.value ? null : r.value)}
          className={`
            flex-1 flex flex-col items-center gap-1 py-2 px-1 rounded-xl border-2 text-xs font-medium transition-colors active:scale-[0.97]
            ${value === r.value
              ? r.color + ' border-current'
              : 'border-transparent bg-nude-50 dark:bg-gray-700 text-nude-400 dark:text-gray-500 hover:bg-nude-100 dark:hover:bg-gray-600'
            }
          `}
        >
          {r.icon}
          {r.label}
        </button>
      ))}
    </div>
  );
}
